import P from "prop-types";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { NextButton, PrevButton, Container } from "./styles";

export function SlideControlButton({ left, right, onClick }) {
  return (
    <Container>
      {left && (
        <PrevButton onClick={onClick}>
          <FaChevronLeft size={16} />
        </PrevButton>
      )}
      {right && (
        <NextButton onClick={onClick}>
          <FaChevronRight size={16} />
        </NextButton>
      )}
    </Container>
  );
}

SlideControlButton.propTypes = {
  left: P.bool,
  right: P.bool,
  onClick: P.func,
};
